'use client';
import { SelectProps, Stack } from '@mui/material';
import TextField from '../text-field';
import { SelectStyled } from './select-styles';
import Icon from '../icon';

const Select = (props: SelectProps) => {
  const template: JSX.Element = (
    <SelectStyled
      IconComponent={(props) => (
        <Stack mt={0.25} {...props}>
          <Icon name="down-arrow" size="small" />
        </Stack>
      )}
      {...props}
      input={<TextField />}
    />
  );

  return template;
};

export default Select;
